import styled, { css } from 'styled-components';
import { device } from '../breakpoints';
import { accentGreen, darkCoolGrey, playGrey20, playGrey15 } from '../design-tokens';

export const ProgressbarContainer = styled.div`
    display: none;
    display: block;
    width: 100%;

    @media ${device.GteMedium} {
        box-sizing: border-box;
        display: block;
        width: 100%;
    }
`;
export const StyledProgressbar = styled.span`
    height: 5px;
    margin-top: 5px;
    background-color: ${playGrey15};
    display: block;

    ${(props) =>
        props.isSelected &&
        css`
            background-color: ${playGrey20};
        `}

    &.play_is--inactive {
        visibility: hidden;
    }
`;

export const ProgressbarValue = styled.div`
    transition: width 1s ease;
    background-color: ${darkCoolGrey};
    height: 100%;

    ${(props) =>
        props.isSelected &&
        css`
            transition: width 1s ease;
            background-color: ${accentGreen};
            height: 100%;
        `}

    ${(props) => css`
        width: ${props.progressPercent}%;
    `}
`;
